module.exports = __webpack_public_path__ + "static/media/bingosafari.9bf69a4a.png";